import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf980d12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position-relative" }

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CopyButton',
  props: {
  content: String,
},
  setup(__props, { expose: __expose }) {

const props = __props;



const showTip = ref(false);

const copy = (event) => {
  event.preventDefault();
  navigator.clipboard.writeText(props.content);

  showTip.value = true;
  setTimeout(() => {
    showTip.value = false;
  }, 1000);
};

__expose({
  copy,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn-light btn-primary btn-sm",
      onClick: copy
    }, _toDisplayString(_ctx.$t("action.copy")), 1),
    _createElementVNode("span", {
      class: _normalizeClass(["tip fs-8 badge badge-light", { 'show-tip-animation': showTip.value }])
    }, _toDisplayString(_ctx.$t("tip.copiedToClipboard")), 3)
  ]))
}
}

})